exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".gravatar-pic[data-v-1b61714e]{border-radius:50%;width:100px;display:initial;margin-bottom:6px}", ""]);

// exports
